import { render, staticRenderFns } from "./statisticsData.vue?vue&type=template&id=0db2d268&scoped=true&"
import script from "./statisticsData.vue?vue&type=script&lang=js&"
export * from "./statisticsData.vue?vue&type=script&lang=js&"
import style0 from "./statisticsData.vue?vue&type=style&index=0&id=0db2d268&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db2d268",
  null
  
)

export default component.exports